import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Descriptions, Button, Tag, Flex, Spin } from "antd";
// import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import actions from "../redux/examination/actions";
import config from "../Services/apiEndPoints";
import { useSelector, useDispatch } from "react-redux";
import { ArrowLeftOutlined } from "@ant-design/icons";

export default function ExamResults() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const studentId = localStorage.getItem("Student_Id");
  const exam_id = localStorage.getItem("examId");
  const { studentresult_response, errorMessage } = useSelector(
    (state) => state.Examination
  );
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const exam_end_time = localStorage.getItem("exam_end_time");

  useEffect(() => {
    if (exam_end_time) {
      const examEndDate = new Date(exam_end_time); // Convert to Date object

      const interval = setInterval(() => {
        const now = new Date();
        if (now >= examEndDate) {
          setIsButtonEnabled(true);
          clearInterval(interval);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, []);

  const handleViewAnswerKey = () => {
    navigate("/dashboard/examAnsKey");
  };

  console.log(studentresult_response);

  const getresult = useCallback(() => {
    dispatch(actions.resetActionType1());
    dispatch(
      actions.resultget(
        `${config.getresult}?student_id=${studentId}&exam_id=${exam_id}`
      )
    );
    setLoading(false);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      getresult();
    }, 500);

    return () => clearTimeout(timer); // Cleanup timeout on unmount
  }, []);

  return (
    <>
      <Button
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate("/dashboard/previousExamsList")}
        style={{ width: "50px", marginTop: "15px", marginLeft: "8px" }}
      ></Button>
      <div>
        {loading ? (
          <Flex  style={{display:"flex",justifyContent:'center',alignItems:'center'}}>
            <Spin />
          </Flex>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <Row justify="center" style={{ padding: "20px", width: "70%" }}>
              <Col span={24} md={24} lg={22} style={{ padding: "20px" }}>
                <Card style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}>
                  <Row
                    gutter={16}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Col span={24} md={20}>
                      <Card
                        title="Results Summary"
                        bordered={false}
                        style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}
                      >
                        <Descriptions column={1} colon={false}>
                          <Descriptions.Item
                            label="Marks Got"
                            labelStyle={{
                              width: 180,
                              textAlign: "left",
                              fontWeight: "bold",
                            }}
                          >
                            {studentresult_response?.student_obtained_marks} /{" "}
                            {studentresult_response?.total_marks}
                          </Descriptions.Item>
                          <Descriptions.Item
                            label="Correct Answers"
                            labelStyle={{
                              width: 180,
                              textAlign: "left",
                              fontWeight: "bold",
                            }}
                          >
                            {studentresult_response?.correct_questions}
                          </Descriptions.Item>
                          <Descriptions.Item
                            label="Wrong Answers"
                            labelStyle={{
                              width: 180,
                              textAlign: "left",
                              fontWeight: "bold",
                            }}
                          >
                            {studentresult_response?.wrong_questions}
                          </Descriptions.Item>
                          <Descriptions.Item
                            label="Attempted Questions"
                            labelStyle={{
                              width: 180,
                              textAlign: "left",
                              fontWeight: "bold",
                            }}
                          >
                            {studentresult_response?.attempted_questions}
                          </Descriptions.Item>
                          <Descriptions.Item
                            label="Not Attempted Questions"
                            labelStyle={{
                              width: 180,
                              textAlign: "left",
                              fontWeight: "bold",
                            }}
                          >
                            {studentresult_response?.not_attempted_questions}
                          </Descriptions.Item>
                          <Descriptions.Item
                            label="Result"
                            labelStyle={{
                              width: 180,
                              textAlign: "left",
                              fontWeight: "bold",
                            }}
                          >
                            {/* {data?.is_qualified ? (
                          <Tag color="green">Pass</Tag>
                        ) : (
                          <Tag color="red">Fail</Tag>
                        )} */}
                            {errorMessage === "Results not found." ? (
                              <Tag color="red">Fail (Absent)</Tag>
                            ) : studentresult_response?.is_qualified ? (
                              <Tag color="green">Pass</Tag>
                            ) : (
                              <Tag color="red">Fail</Tag>
                            )}
                          </Descriptions.Item>
                        </Descriptions>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "20px",
                          }}
                        >
                          <Button
                            type="primary"
                            onClick={handleViewAnswerKey}
                            style={{ width: "200px" }}
                            disabled={!isButtonEnabled}
                          >
                            View Answer Sheet
                          </Button>
                        </div>
                      </Card>
                    </Col>
                    {/* <Col span={24} md={12}>
              <Card
                title="Score Distribution by Subject"
                bordered={false}
                style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}
              >
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={pieChartData}
                      dataKey="value"
                      nameKey="name"
                      outerRadius={120}
                      label
                    >
                      {pieChartData.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={["#ff6347", "#4caf50"][index]}
                        />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
              </Card>
            </Col> */}
                  </Row>
                </Card>
              </Col>
            </Row>
          </div>
        )}
      </div>
    </>
  );
}
